import { ChrThemeGenerator as i, contrastPredicate as o, themeGenerator as h } from "./theme-generator/theme-generator.js";
import { calculateHSLColor as l, defaultHSLOptions as m, defaultThemeData as n, getDefaultThemeData as s, getMatchingPrimitiveToken as g, getTokenLastSubstring as p, shadePairs as d } from "./theme-generator/theme-generator.utils.js";
import { ChrLocalization as u, registerLocalization as L } from "./localization/localization.js";
const e = [{
    id: "ciphr-light",
    name: "CIPHR",
    mode: "light",
    default: !0,
    className: "chr-ciphr-light",
    themeDir: "ciphr-light"
  }],
  t = e;
export { u as ChrLocalization, i as ChrThemeGenerator, l as calculateHSLColor, o as contrastPredicate, m as defaultHSLOptions, n as defaultThemeData, s as getDefaultThemeData, g as getMatchingPrimitiveToken, p as getTokenLastSubstring, L as registerLocalization, d as shadePairs, h as themeGenerator, t as themesMeta };